const CLASSIC = "classic";
const COUPE = "coupe";
const METRO = "metro";
const EXEC = "exec";
const SPORT = "sport";

const METRO_ISSUES = [
  {
    tag: "CAP",
    title: "Cap of umbrella missing or damaged",
    description:
      "If you require a replacement cap for your umbrella please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-issue-cap.jpg?v=108747625761267714091787624901",
  },

  {
    tag: "TIP",
    title: "Tip or spring of umbrella is missing or damaged",
    description:
      "If one or more tips or springs are missing, or no longer in place, please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-issue-tip.jpg?v=34657991338333092171787624902",
  },
  
  // {
  //   tag: "CANOPY-MAIN",
  //   title: "Canopy fabric damage or fault",
  //   description:
  //     "If your umbrella canopy has holes, velcro issues or faulty stitching, please select this option",
  //   image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-canopy.jpg?v=18297045415560324161787624882",
  // },

  {
    tag: "RIB_SET",
    title: "Damage to the umbrella frame",
    description:
      "If the frame components are damaged, please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-issue-frame.jpg?v=101218605758557822211787624901",
  },

  
  {
    tag: "HANDLE",
    title: "Handle and/or handle strap missing or damaged",
    description:
      "If your handle or handle strap is damaged, please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-issue-handle.jpg?v=71665587624037418911787624902",
  },
];

const NON_METRO_ISSUES = [
  {
    tag: "CAP",
    title: "Cap of umbrella missing or damaged",
    description:
      "If you require a replacement cap for your umbrella please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-cap.jpg?v=28472350271766423161787624883",
  },
  
  {
    tag: "TIP",
    title: "Tip of umbrella is missing or damaged",
    description:
      "If one or more tips or springs are missing, or no longer in place, please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-tip.jpg?v=131333506439067304481787624883",
  },

  {
    tag: "CANOPY-MAIN",
    title: "Canopy fabric damage or fault",
    description:
      "If your umbrella canopy has holes, velcro issues or faulty stitching, please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-canopy.jpg?v=18297045415560324161787624882",
  },

  {
    tag: "HANDLE",
    title: "Handle and/or handle strap missing or damaged",
    description:
      "If your handle or handle strap is damaged please select this option",
    image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-handle.jpg?v=179525691998989545291787624884",
  },
];

const ADDITIONAL_INFORMATION_CONFIGS = [
  // Cap Issues in Metro, Classic
  {
    issue_tag: "CAP",
    products: [METRO, CLASSIC],
    questions: [
      {
        choices: [
          {
            tag: "NEW_CAP",
            title: "Cap Version 2",
            description: "Select this option if your umbrella has a thread showing at the top of the umbrella",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-cap-new.jpg?v=168251029186914239211787624877",
            overrides: {          
              [METRO]: {
                title: "Metro Cap Version 2",
                description: "Select this option if the connection point at the top of the umbrella has 2x slots. Note: this version can come with both old and new branding",
                image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-new-cap.jpg?v=42288042538066718861787624902",
              },
            }
          },
          {
            tag: "OLD_CAP",
            title: "Cap Version 1",
            description: "Select this option if your umbrella does not have a thread at the top of the umbrella",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-cap-old.jpg?v=75009992375395382021787624878",
            overrides: {          
              [METRO]: {
                title: "Metro Cap Version 1",
                description: "Select this option if the connection point at the top of the umbrella has either 0 or 1 slot.",
                image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-old-cap.jpg?v=173015790104945660951787624903",
              },
            }
          },
        ]
      }
    ]
  },
  // Canopy Issues in Metro, Coupe, Classic, Exec, Sport
  {
    issue_tag: "CANOPY-MAIN",
    products: [METRO, COUPE, CLASSIC, EXEC, SPORT],
    questions: [
      {
        choices: [
          {
            tag: "SMALL_HOLE",
            title: "Canopy damage (small)",
            description:
              "Select this option if hole is less than 5x25mm and is not on a seam, tip pocket or the canopy strap (velcro)",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/canopy-small-hole.jpg?v=82339040084081764481787624876",
          },
          {
            tag: "LARGE_HOLE",
            title: "Canopy damage (large)",
            description:
              "If the damage is greater than 5x25mm, located on a seam, tip pocket or on canopy strap (velcro) select this option",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/canopy-big-hole.jpg?v=125796909961044496851787624879",
          }
        ]
      }
    ],
  },
  // Handle Issues in Metro
  {
    issue_tag: "HANDLE",
    products: [METRO],
    questions: [
      {
        choices: [
          {
            tag: "HANDLE_1",
            title: "Does your handle / shaft look like this?",
            description:
              "The circle surrounding the strap is black. If you are missing your strap and/or handle, is the bottom of the shaft a threaded fitting?",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-handle-black-v2.jpg?v=67123571610386112111787624900",
          },
          {
            tag: "HANDLE_2",
            title: "Or do they look like this?",
            description:
              "The circle surrounding the strap is grey. If you are missing your strap and/or handle, is the bottom of the shaft a bayonet fitting?",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-handle-grey-v2.jpg?v=104785586294539433941787624900",
          },
        ]
      },
      {
        when: ["HANDLE_1"],
        choices: [
          {
            tag: "HANDLE_DAMAGED",
            title: "Handle damaged?",
            description:
              "Select this option if part of the handle is broken or damaged. ",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-broken-handle.jpg?v=173048424092171880071787624904",
          },
          {
            tag: "STRAP_DAMAGED",
            title: "Handle strap damaged?",
            description:
              "Select this option if it’s just the handle strap that is damaged.",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/metro-broken-strap.jpg?v=83099093414035705641787624904",
          },
        ]
      }
    ],
    partVariants: [
      { 
        sku: "SPMETHANT", 
        when: { 
          taggedWith: ["HANDLE_1", "HANDLE_DAMAGED"],
        },
      },
      { 
        sku: "SPMETSTRAPT", 
        when: { 
          taggedWith: ["HANDLE_1", "STRAP_DAMAGED"],
        },
      },
    ]
  },
  // Handle Issues in Coupe
  {
    issue_tag: "HANDLE",
    products: [COUPE],
    questions: [
      {
        choices: [
          {
            tag: "HANDLE_1",
            title: "Handle and/or strap broken?",
            description:
              "Select this option if either the handle or strap is broken or damaged",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-handle.jpg?v=179525691998989545291787624884",
          },
          {
            tag: "HANDLE_2",
            title: "Handle attachment part is broken?",
            description:
              "Select this option if attachment system on the shaft is broken",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/handle-inner.jpg?v=65712746772427097161787624888",
          },
        ]
      }
    ]
  },
  // Handle Issues in Sport
  {
    issue_tag: "HANDLE",
    products: [SPORT],
    questions: [
      {
        choices: [
          {
            tag: "HANDLE_1",
            title: "Handle and/or strap broken?",
            description:
              "Select this option if either the handle or strap is broken or damaged",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-handle.jpg?v=179525691998989545291787624884",
          },
          {
            tag: "HANDLE_2",
            title: "Handle attachment part is broken?",
            description:
              "Select this option if attachment system on the shaft is broken",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/handle-inner.jpg?v=65712746772427097161787624888",
          },
        ]
      },
      {
        when: ["HANDLE_1"],
        choices: [
          {
            tag: "SPORT_WITH_END_SLOT",
            title: "Has an end slot?",
            description:
              "Select this option if at the bottom of the handle there is a single line slot in the fastener. Or if the fastener is missing, there is an open end.",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/sport-end-gap.jpg?v=25897961257777073641787624912",
          },
          {
            tag: "SPORT_WITHOUT_END_SLOT",
            title: "No end slot?",
            description:
              "Select this option if there is no single line slot in the end of the handle profile.",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/sport-no-end-gap.jpg?v=67721538406208082871787624917",
          },
        ]
      }
    ],
    partVariants: [
      { 
        sku: "SPSPOHANT", 
        when: { 
          taggedWith: ["HANDLE_1", "SPORT_WITH_END_SLOT"],
        },
      },
      { 
        sku: "SPSPOHAN", 
        when: { 
          taggedWith: ["HANDLE_1", "SPORT_WITHOUT_END_SLOT"],
        },
      },
    ]
  },
  // Handle Issues in Classic
  {
    issue_tag: "HANDLE",
    products: [CLASSIC, EXEC],
    questions: [
      // Classic handle
      {
        choices: [
          {
            tag: "HANDLE_1",
            title: "Handle and/or strap broken?",
            description:
              "Select this option if either the handle or strap is broken or damaged",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/issue-handle.jpg?v=179525691998989545291787624884",
          },
          {
            tag: "HANDLE_2",
            title: "Handle attachment part is broken?",
            description:
              "Select this option if attachment system on the shaft is broken",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/handle-inner.jpg?v=65712746772427097161787624888",
          },
        ]
      },
      // Classic Strap
      {
        choices: [
          {
            tag: "STRAP_1",
            title: "Handle with a strap?",
            description:
              "Select this option if your handle originally came with a strap",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-handle-strap.jpg?v=60004509365200939371787624872",
          },
          {
            tag: "STRAP_2",
            title: "Handle without a strap?",
            description:
              "Select this option if your handle did not come with a handle strap",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-handle-no-strap.jpg?v=31306293688791287791787624872",
          },
        ] 
      },
      // Strap gap or no gap
      {
        when: ["HANDLE_1"],
        choices: [
          {
            tag: "END_WITH_GAP",
            title: "A gap?",
            description:
              "Select this option if there is a gap between where the strap meets the handle. As indicated.",
              image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-end-gap.jpg?v=54767505001437347111787624878",
          },
          {
            tag: "END_WITHOUT_GAP",
            title: "No gap?",
            description:
              "Select this option if there is NO gap or space between where the ends of the strap meet the handle.",
              image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-end-no-gap.jpg?v=130224565009375223621787624871",
          },
        ] 
      },
      {
        when: ["HANDLE_1"],
        choices: [
          {
            tag: "HANDLE_DAMAGED",
            title: "Handle damaged?",
            description:
              "Select this option if part of the handle is broken or damaged. ",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/claasic-threaded-broken-handle-no-gap.jpg?v=72998187428131025721787624877",
          },
          {
            tag: "STRAP_DAMAGED",
            title: "Handle strap damaged?",
            description:
              "Select this option if it’s just the handle strap that is damaged.",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/classic-bayonet-broken-strap.jpg?v=170263888765379665601787624877",
          },
        ]
      }
    ],
    partVariants: [
      // Classic
      { 
        sku: "SPCLAHAN", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITH_GAP", "HANDLE_DAMAGED"],
          productIn: [CLASSIC],
        }
      },
      { 
        sku: "SPCLASTRAPB", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITH_GAP", "STRAP_DAMAGED"],
          productIn: [CLASSIC],
        }
      },
      { 
        sku: "SPCLAHANT", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITHOUT_GAP", "HANDLE_DAMAGED"],
          productIn: [CLASSIC],
        }
      },
      { 
        sku: "SPCLASTRAPT", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITHOUT_GAP", "STRAP_DAMAGED"],
          productIn: [CLASSIC],
        }
      },
     
      // Exec
      { 
        sku: "SPEXEHAN", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITH_GAP", "HANDLE_DAMAGED"],
          productIn: [EXEC],
        }
      },
      { 
        sku: "SPEXESTRAPB", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITH_GAP", "STRAP_DAMAGED"],
          productIn: [EXEC],
        }
      },
      { 
        sku: "SPEXEHANT", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITHOUT_GAP", "HANDLE_DAMAGED"],
          productIn: [EXEC],
        }
      },
      { 
        sku: "SPEXESTRAPT", 
        when: { 
          taggedWith: ["HANDLE_1", "END_WITHOUT_GAP", "STRAP_DAMAGED"],
          productIn: [EXEC],
        }
      },
    ],
  },
  // Exec TIP variants
  {
    issue_tag: "TIP",
    products: [EXEC],
    questions: [
      {
        choices: [
          {
            tag: "EXEC_TIP_1",
            title: "Exec Tip Version 1",
            description: "Select this option if the tips of your Exec model are black down the centreline",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/exec-black-broken-tip.jpeg?v=139016317727407479851787624892",
          },
          {
            tag: "EXEC_TIP_2",
            title: "Exec Tip Version 2",
            description: "Select this option if the tips of your Exec model are grey down the centreline",
            image: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/exec-grey-broken-tip.jpeg?v=27256094790438015071787624887",
          },
        ]
      }
    ],
    partVariants: [
      { sku: "SPEXETS", when: { taggedWith: ["EXEC_TIP_1"] } },
      { sku: "SPEXETS2", when: { taggedWith: ["EXEC_TIP_2"] } },
    ],
  },
];

const CLASSIC_SKELETON_SIDE = {
  backdrop: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Base_Side.svg?v=133135727578995498721787624845",
  checkboxes: [
    {
      tag: "RIB_SET",
      positionX: 75,
      positionY: 9.1,
      label: "Rib Set",
      labelOffsetX: "-30px",
      labelOffsetY: "26px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Ribs_Side.svg?v=105791736068398392121787624509",
    },
    {
      tag: "RUNNER",
      positionX: 47.4,
      positionY: 19,
      label: "Runner",
      labelOffsetX: "0px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Runner_Side.svg?v=116545250514717277981787624509",
    },
    {
      tag: "TIP",
      positionX: 68.3,
      positionY: 35.5,
      label: "BLUNT Tip and Spring",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Tips_Side.svg?v=50364844081791749241787624506",
    },
    {
      tag: "SHAFT",
      positionX: 47.4,
      positionY: 50,
      label: "Shaft",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Shaft_Side.svg?v=26649998080337499581787624510",
    },
    {
      tag: "HANDLE",
      positionX: 47.4,
      positionY: 78.8,
      label: "Handle",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Handle_Side.svg?v=15733555435489256321787624509",
    },
  ],
};

const CLASSIC_SKELETON_TOP = {
  backdrop: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Base_Top.svg?v=103684322690804151871787624507",
  checkboxes: [
    {
      tag: "CANOPY-MAIN",
      positionX: 21.7,
      positionY: 30.8,
      label: "Canopy",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Canopy_Top.svg?v=180082500706401719711787624508",
    },
    {
      tag: "CANOPY-TIE",
      positionX: 47.3,
      positionY: 8.5,
      label: "Canopy Tie",
      labelOffsetX: "-35px",
      labelOffsetY: "40px",
      tip: "Please note depending on Canopy Tie damage, may require a canopy replacement",
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_CanopyTie_Top.svg?v=117252568128076428891787624507",
    },
    {
      tag: "CAP",
      positionX: 47.4,
      positionY: 47.155,
      label: "Cap",
      labelOffsetX: "-35px",
      labelOffsetY: "40px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Classic_Cap_Top.svg?v=170889871102066666221787624508",
    },
  ],
};

const METRO_SKELETON_SIDE = {
  backdrop: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Base_Side.svg?v=32268182011495502741787624839",
  checkboxes: [
    {
      tag: "RIB_SET",
      positionX: 74,
      positionY: 10.1,
      label: "Rib Set",
      labelOffsetX: "-34px",
      labelOffsetY: "27px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Ribs_Side.svg?v=61257303311915554061787624840",
    },
    {
      tag: "RUNNER",
      positionX: 47.4,
      positionY: 19,
      label: "Runner",
      labelOffsetX: "-10px",
      labelOffsetY: "15px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Runner_Side.svg?v=146366800008383384351787624509",
    },
    {
      tag: "TIP",
      positionX: 66.3,
      positionY: 43.5,
      label: "BLUNT Tip and Spring",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Tips_Side.svg?v=37976106351784603361787624506",
    },
    {
      tag: "SHAFT",
      positionX: 47.4,
      positionY: 50,
      label: "Shaft",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Shaft_Side.svg?v=21331935589658445881787624510",
    },
    {
      tag: "HANDLE",
      positionX: 47.4,
      positionY: 78.5,
      label: "Handle",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Handle_Side.svg?v=138240550101255627691787624509",
    },
  ],
};

const METRO_SKELETON_TOP = {
  backdrop: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Base_Top.svg?v=33447521886278857431787624507",
  checkboxes: [
    {
      tag: "CANOPY-MAIN",
      positionX: 21.7,
      positionY: 30.8,
      label: "Canopy",
      labelOffsetX: "10px",
      labelOffsetY: "0px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Canopy_Top.svg?v=32099357381990343591787624508",
    },
    {
      tag: "CANOPY-TIE",
      positionX: 47.3,
      positionY: 5.3,
      label: "Canopy Tie",
      labelOffsetX: "-35px",
      labelOffsetY: "40px",
      tip: "Please note depending on Canopy Tie damage, may require a canopy replacement",
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_CanopyTie_Top.svg?v=152257016228956488491787624508",
    },
    {
      tag: "CAP",
      positionX: 47.4,
      positionY: 46.8,
      label: "Cap",
      labelOffsetX: "-35px",
      labelOffsetY: "40px",
      tip: null,
      layer: "//bluntumbrellas.co.nz/cdn/shop/t/362/assets/Metro_Cap_Top.svg?v=20266673119073651761787624509",
    },
  ],
};

const MANUFACTURERS_WARRANTY = "MANUFACTURERS_WARRANTY";
const EXTENDED_WARRANTY = "EXTENDED";
const OUT_WARRANTY = "OUT";

const REPAIR_POSSIBILITY_MATRIX = {};

// prettier-ignore
REPAIR_POSSIBILITY_MATRIX[CLASSIC] = {
  CAP: [
    { variation: "NEW_CAP", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "OLD_CAP", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "NEW_CAP", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "OLD_CAP", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },

    { variation: "NEW_CAP", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
    { variation: "OLD_CAP", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: false, blunt_cost: 1 },
  ],
  SHAFT: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  RUNNER: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 4 },
  ],
  RIB_SET: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 3 },
  ],
  TIP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  HANDLE: [
    { variation: "HANDLE_1", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },  

    { variation: "HANDLE_1", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },

    { variation: "HANDLE_1", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 10, blunt_cost: 10 },
    { variation: "HANDLE_2", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 10, blunt_cost: 10 },

//    // Classic handle strap
//    { variation: "STRAP_1", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
//    { variation: "STRAP_2", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },  
//
//    { variation: "STRAP_1", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
//    { variation: "STRAP_2", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
//
//    { variation: "STRAP_1", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 0 },
//    { variation: "STRAP_2", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 0 },
  ],
  "CANOPY-MAIN": [
    { variation: "SMALL_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "SMALL_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 20 },
    { variation: "LARGE_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 20 },

    { variation: "SMALL_HOLE", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 20 },
    { variation: "LARGE_HOLE", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ],
  "CANOPY-TIE": [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ]
};

// prettier-ignore
REPAIR_POSSIBILITY_MATRIX[METRO] = {
  CAP: [
    { variation: "OLD_CAP", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "NEW_CAP", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },

    { variation: "OLD_CAP", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "NEW_CAP", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },

    { variation: "OLD_CAP", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 1 },
    { variation: "NEW_CAP", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  SHAFT: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  RUNNER: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 3 },
  ],
  RIB_SET: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 3 },
  ],
  TIP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  HANDLE: [
    { variation: "HANDLE_1", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },

    { variation: "HANDLE_1", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    
    { variation: "HANDLE_1", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 5 },
    { variation: "HANDLE_2", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 5 },
  ],
  "CANOPY-MAIN": [
    { variation: "SMALL_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    // Maybe for small hole price was supposed to be 0?
    { variation: "SMALL_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 20 },
    { variation: "LARGE_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },

    { variation: "SMALL_HOLE", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 20 },
    { variation: "LARGE_HOLE", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ],
  "CANOPY-TIE": [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ]
},

// prettier-ignore
REPAIR_POSSIBILITY_MATRIX[COUPE] = {
  CAP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },  
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  SHAFT: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  RUNNER: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 3 },
  ],
  RIB_SET: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 3 },
  ],
  TIP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  HANDLE: [
    { variation: "HANDLE_1", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "HANDLE_1", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },

    { variation: "HANDLE_1", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 5 },
  ],
  "CANOPY-MAIN": [
    { variation: "SMALL_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "SMALL_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },

    { variation: "SMALL_HOLE", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
    { variation: "LARGE_HOLE", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ],
  "CANOPY-TIE": [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ]
},

// prettier-ignore
REPAIR_POSSIBILITY_MATRIX[EXEC] = {
  CAP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },  
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  SHAFT: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  RUNNER: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 0 },
  ],
  RIB_SET: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 4 },
  ],
  TIP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  HANDLE: [
    { variation: "HANDLE_1", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "HANDLE_1", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },

    { variation: "HANDLE_1", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  "CANOPY-MAIN": [
    { variation: "SMALL_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "SMALL_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 25 },

    { variation: "SMALL_HOLE", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
    { variation: "LARGE_HOLE", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 25 },
  ],

  "CANOPY-TIE": [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ]
},

// prettier-ignore
REPAIR_POSSIBILITY_MATRIX[SPORT] = {
  CAP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },  
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  SHAFT: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  RUNNER: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 4 },
  ],
  RIB_SET: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: 1, blunt_cost: 4 },
  ],
  TIP: [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
  ],
  HANDLE: [
    { variation: "HANDLE_1", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "HANDLE_1", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "HANDLE_2", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },

    { variation: "HANDLE_1", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 10, blunt_cost: 10 },
    { variation: "HANDLE_2", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 10 },
  ],
  
  "CANOPY-MAIN": [
    { variation: "SMALL_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },  

    { variation: "SMALL_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 0, blunt_cost: 0 },
    { variation: "LARGE_HOLE", warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 25 },

    { variation: "SMALL_HOLE", warranty: OUT_WARRANTY, customer_repair: true, blunt_repair: true, customer_cost: 1, blunt_cost: 1 },
    { variation: "LARGE_HOLE", warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 25 },
  ],

  "CANOPY-TIE": [
    { variation: null, warranty: MANUFACTURERS_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 0 },
    { variation: null, warranty: EXTENDED_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
    { variation: null, warranty: OUT_WARRANTY, customer_repair: false, blunt_repair: true, customer_cost: null, blunt_cost: 20 },
  ]
};
